export const SITE_TITLE = "株式会社よね一";
export const SITE_DESCRIPTION =
  "牛肉の卸売会社。村上牛、仙台牛など各種銘柄和牛はじめ国産牛をメインに、牛肉関連商品を幅広く取り扱っております。国産和牛、国産牛肉等の加工品の商品開発・製造・販売を展開。海外輸出にも注力し、食肉のグローバル化に柔軟に対応しております。";
export const SITE_URL = "https://yoneichi.co.jp";
export const SITE_OG_IMAGE = "";

export const GOOGLE_RECAPTCHA_KEY = "6Le5wjEbAAAAABM8gW-2N9D9eS-UV4uWmaMdvp-r";
